// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3RWsn","buttons":"Footer_buttons__t7wqk"};